import { keyframes, css } from 'styled-components';
import { colors } from '../../styles/variables';
import { hexToRgbaString } from '../color-utils';

const INITIAL_COLOR = hexToRgbaString(colors.yellow1, 0);
const HIGHLIGHT_COLOR = hexToRgbaString(colors.yellow1, 0.2);

const highlightNewContentKeyframes = (
  initialColor: string = INITIAL_COLOR,
  transitionColor: string = HIGHLIGHT_COLOR
) => keyframes`
  from {
    background-color: ${initialColor};
  }
  25% {
    background-color: ${transitionColor};
  }
  50% {
    background-color: ${transitionColor};
  }
  to {
    background-color: ${initialColor};
  }
`;

export const HIGHLIGHT_NEW_CONTENT_DURATION = 750;
export const highlightNewContentAnimation = (
  initialColor?: string,
  transitionColor?: string
) =>
  css`
    animation: ${highlightNewContentKeyframes(initialColor, transitionColor)}
      ${HIGHLIGHT_NEW_CONTENT_DURATION}ms ease-out 1;
  `;
